export default {"src":"/_next/static/media/cupcake.183fbbe3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};